;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:synergiefrontends":true});}catch(e){}}();import React from 'react';

function SquaredImage({ src }) {
  return (
    <div className="squardImageContainer">
      <div className="imgFill" style={{ backgroundImage: `url(${src})` }} />
      <div className="redSquare" />
    </div>
  );
}

export default SquaredImage;
